import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/ariqt.webp';
import screenshot_target from '../../../images/letterfunnel/rupeshkumar.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Rupesh Kumar"
      firstname="Rupesh"
      companyname="Ariqt"
      competition="Xebia en Neev"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/rupeshkumar.js